import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="2wiferaffj2x4">
      <MetaPixel data-id="element-1" data-mp="28ufpkexrnkkn" />
      <CountdownBar data-id="element-2" data-mp="28tw6guwdqq51" />
      <main data-id="element-3" data-mp="28te1n9vnj3li">
        <Hero data-id="element-4" data-mp="28t4j27cxrypu" />
        <StatsBar data-id="element-5" data-mp="28sl511qepuh3" />
        <Difference data-id="element-6" data-mp="28s2ynca15zvg" />
        <Recognize data-id="element-7" data-mp="23vkzcrxgytqi" />
        <WhatsInside data-id="element-8" data-mp="23u9tmmkgrbwr" />
        <InsidePages data-id="element-9" data-mp="23utb6267bya9" />
        <Bonuses data-id="element-10" data-mp="23t8eo70bu59r" />
        <Offer data-id="element-11" data-mp="3ijxsv0nzqion" />
        <Guarantee data-id="element-12" data-mp="3ikh9me1wn113" />
        <Testimonials data-id="element-13" data-mp="3iiwasc8k4vxf" />
        <Faq data-id="element-14" data-mp="3ijpd910hgz9r" />
      </main>
      <Footer data-id="element-15" data-mp="3mljat0fdtn5p" />
    </div>;
}